import { Box, Typography, List, ListItem, ListItemIcon } from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import NetWorthCard from './StatsCard/NetWorthCard';

import { OUR_STORY, STORY_DESCRIPTION } from './constants';

export const SbsStory = ({ isVisible = true }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ m: 0, mb: { xs: 0, sm: 2 } }}
      flexDirection={{ xs: 'column', md: 'row' }}
      gap={3}
      textAlign="center"
    >
      {/* Text Section */}
      <Box flex={1}>
        <Box maxWidth={{ xs: 343, md: 375, lg: 556 }} mx={'auto'}>
          <Typography
            gutterBottom
            sx={{
              textWrap: 'pretty',
              fontSize: { xs: '30px', md: '42px' },
              fontWeight: '700',
              lineHeight: { xs: '38.4px', md: '61.44px' },
              fontFamily: 'sans-serif',
            }}
          >
            {OUR_STORY}
          </Typography>
          <Typography
            sx={{
              textWrap: 'pretty',
              fontSize: { xs: '14px', md: '16px' },
              lineHeight: { xs: '22.4px', md: '28.8px' },
              color: '#727272',
              m: { lg: '0 50px' },
              fontFamily: 'sans-serif',
            }}
            gutterBottom
          >
            {STORY_DESCRIPTION}
          </Typography>
          <List>
            {[
              '100 million+ auto loans a year',
              '16 million+ mortgage applications a year',
              '215 million+ drivers have auto insurance',
              '~90% of homes have homeowners insurance',
            ].map((text, index) => (
              <ListItem
                key={index}
                sx={{
                  paddingLeft: 0,
                  fontSize: { xs: '14px', md: '18px' },
                  lineHeight: { xs: '22.4px', md: '28.8px' },
                  color: '#727272',
                  m: { lg: '0 50px' },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: '30px',
                  }}
                >
                  <CheckCircleIcon sx={{ color: 'black' }} />
                </ListItemIcon>
                <Typography
                  variant="body1"
                  sx={{ fontSize: { xs: '14px', md: '16px' }, fontFamily: 'sans-serif' }}
                >
                  {text}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>

      {/* Visual Section */}

      <Box
        flex={1}
        display="flex"
        alignItems="flex-start"
        justifyContent="center"
        mb={4}
        position="relative"
        overflow="hidden"
      >
        <Box
          component="img"
          src="https://res.cloudinary.com/amunoali/image/upload/v1742152952/CashClever/45_rqabor.png" // Replace with your image URL
          alt="Placeholder"
          sx={{
            maxWidth: { xs: 343, lg: 465 },
            minHeight: { xs: 300, lg: 407 },
            borderRadius: '1rem',
            objectFit: 'cover',
            filter: 'grayscale(80%)',
            position: 'relative',
            width: { xs: '100%', md: 'auto' },
          }}
        />
        <Box
          position="absolute"
          display="flex"
          alignItems="flex-start"
          sx={{
            top: { xs: '50%', sm: '50%', md: '40%', lg: '55%' },
            left: { xs: '50%', sm: '10%', md: '0', lg: '10%' },
          }}
        >
          <NetWorthCard isVisible={isVisible} />
        </Box>
      </Box>
    </Box>
  );
};
